import { jsonldReviewBody } from './JsonldStore';

export const updateJsonldReviewBody = (value) => jsonldReviewBody.update((oldValue) => value);
